import { useEffect, useRef } from "react";
import { AUTO_DISMISS_MS, toastStore, useToasts, type Toast } from "../../stores/toastStore";

/** Design: Toast. 5 s auto-dismiss, paused while hovered or focused. */
function ToastItem({ t }: { t: Toast }) {
  const timer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);
  const start = () => { timer.current = setTimeout(() => toastStore.getState().dismiss(t.id), AUTO_DISMISS_MS); };
  const pause = () => clearTimeout(timer.current);
  useEffect(() => { start(); return pause; }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div className="toast" role="status" onMouseEnter={pause} onMouseLeave={start} onFocus={pause} onBlur={start}>
      <span className="toast__check" aria-hidden>✓</span>
      <span className="toast__msg">{t.message}</span>
      {t.actionLabel && (
        <button className="toast__action" onClick={() => { t.onAction?.(); toastStore.getState().dismiss(t.id, true); }}>
          {t.actionLabel}
        </button>
      )}
    </div>
  );
}

export function Toaster() {
  const toasts = useToasts((s) => s.toasts);
  return <div className="toaster" aria-live="polite">{toasts.map((t) => <ToastItem key={t.id} t={t} />)}</div>;
}
